import _ from "lodash";

function trackNavScroll(currentNavElement: HTMLDivElement | null) {
  if (currentNavElement === null) {
    return;
  }

  sessionStorage.setItem(
    "navScrollPosition",
    currentNavElement.scrollTop.toString(),
  );
}

export function createScrollHandler(
  scrollContainerRef: React.RefObject<HTMLDivElement>,
) {
  return _.debounce(() => {
    trackNavScroll(scrollContainerRef.current);
  }, 200);
}

export function restoreScrollPosition(
  scrollContainerRef: React.RefObject<HTMLDivElement>,
) {
  if (scrollContainerRef.current) {
    scrollContainerRef.current.scrollTop = parseInt(
      sessionStorage.getItem("navScrollPosition") ?? "0",
      10,
    );
  }
}

export function resetScrollPosition() {
  sessionStorage.setItem("navScrollPosition", "0");
}
